"use strict";

import React from 'react';

const buildOption = (option, index) => {
    if (!!option.children) {
        return (<optgroup label={option.label} key={index}>
            {option.children.map((childOption, childIndex) => {
                return buildOption(childOption, childIndex);
            })}
        </optgroup>);
    }
    return (<option value={option.value} key={index} disabled={option.disabled}>{option.label}</option>);
}

function FormSelect({value='', name='', required=false, options=[], onChange=()=>{},
                        onBlur=()=>{}, className='', style={}, disabled = false}) {
    return (
        <select name={name} value={value} onChange={onChange}
                onBlur={onBlur} required={!!required}
                className={className}
                style={style} disabled={disabled}>
            { options.map( (option, index) =>
                buildOption(option, index)
            )}
        </select>
    );
}

export default FormSelect;
